export interface MatomoData {
  matomo_domains: string[];
  matomo_tracker_url: string;
  matomo_siteId: string;
  matomo_tracker_script: string;
  matomo_tag_manager_script: string;
}
